'use strict';

var isRequired = function isRequired(name) {
    var param = name === undefined ? '' : name;
    throw new Error('Missing parameter ' + param);
};

var index = {
    isRequired: isRequired
};

module.exports = index;
